// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y96c","top":"styles_top__1xkdi"};